import React from 'react';
import { getWhatsAppLink } from '../data/business';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
interface WhatsAppButtonProps {
  label?: string;
  variant?: 'solid' | 'outline' | 'onEmerald';
  className?: string;
}

/**
 * Enlaza a WhatsApp cuando hay un número configurado; de lo contrario
 * lleva a la sección de contacto para no dejar un enlace roto.
 */
export function WhatsAppButton({
  label = 'Escribir vía WhatsApp',
  variant = 'solid',
  className = ''
}: WhatsAppButtonProps) {
  const link = getWhatsAppLink();
  const base = 'inline-flex items-center justify-center gap-2 rounded-sm px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] transition-colors duration-200';
  const styles = {
    solid: 'bg-gold-500 text-graphite-900 hover:bg-gold-400',
    outline: 'border border-emerald-600 text-emerald-700 hover:bg-emerald-600 hover:text-ivory-50',
    onEmerald: 'bg-gold-400 text-graphite-900 hover:bg-gold-300'
  }[variant];
  return <a href={link ?? '#contacto'} target={link ? '_blank' : undefined} rel={link ? 'noopener noreferrer' : undefined} className={`${base} ${styles} ${className}`} data-id="element-180" data-mp="8cvaqgpak4fu">
      <WhatsAppIcon className="h-4 w-4" data-id="element-181" data-mp="iasvuvbutl48" />
      <span data-id="element-182" data-mp="ibu7b0ws89mh">{label}</span>
    </a>;
}